import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { ButtonLoader } from "components/__new/common/form";
import FormDrawer from "components/__new/common/form-drawer";
import * as approvalAction from 'store/entities/approvals/action';

const CancelRequest = (props) => {
    const dispatch = useDispatch();
    const {isOpen, setIsOpen, onOpenCancelRequest, request, getRequests} = props;
    const { cancelledRequestLoading, cancelledRequest } = useSelector(s => s.entities.approvals);
    // const [form, setForm] = useState({
    //     reason: "",
    // })

    const handleCancelRequest = () => {
        const requestId = request?.id;
        // const payload = {rejectReason: form?.reason};
        dispatch(approvalAction.cancelRequest(requestId));
    }
    
    // const isFormValid = form?.reason;

    useEffect(() => {
        if (cancelledRequest?.error === false) {
            getRequests()
            setIsOpen(false);
            toast.success('Request successfully cancelled');
            onOpenCancelRequest?.();
            dispatch(approvalAction.resetCancelRequest());
        }
    }, [cancelledRequest, dispatch]);
    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Cancel Request"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <div className="mt-4">
                    <div className="flex items-center text-[#4A5564] font-normal">
                        Are you sure you want to cancel this request?
                    </div>
                </div>

                <div className="p-1 mt-4 flex items-center space-x-3">
                    <ButtonLoader type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-[#DC2626] text-white bg-[#DC2626]"
                        onClick={handleCancelRequest}
                        loading={cancelledRequestLoading}
                    >
                        Yes, Cancel
                    </ButtonLoader>
                    <button type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                        onClick={() => setIsOpen(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}


export default CancelRequest;